import { IBaseResponseModel, IBaseValueModel } from './base.model';
import { IVehicle } from './vehicle.model';

export interface IUserModel {
  id: string;
  firstName: string;
  lastName: string;
  middleName: string;
  phoneNumber: string;
  photoPath?: string;
}

export interface IUserSearch {
  uuid: IBaseValueModel;
  email: string;
  phone: string;
  createdAt: Date;
  firstName: string;
  lastName: string;
  middleName: string;
  fullName: string;
  birthdate: Date;
  accountId: string;
}

export interface IUserListItem extends IUserSearch {
  isEmployee: boolean;
  lastActivityDate: string;
  vehiclesCount: number;
  vrps: string[];
  roles: IUserRoleEnum[];
  status: IUserStatusEnum;
}

export interface IUserListResponseModel extends IBaseResponseModel {
  users: IUserListItem[];
}

export interface IUserDetailsResponseModel {
  user: IUserDetails;
}

export interface IUserDetails extends IUserSearch {
  vehicles: IVehicle[];
  roles: IUserRoleEnum[];
  status: IUserStatusEnum;
  isEmployee: boolean;
  lastActivityDate: string;
}

export enum IUserStatusEnum {
  Active = 'USER_STATUS_ACTIVE',
  Unspecified = 'USER_STATUS_UNSPECIFIED',
  Blocked = 'USER_STATUS_BLOCKED',
  Deleted = 'USER_STATUS_DELETED',
}

export enum IUserSearchBy {
  VRP = 2,
  ANY = 5,
}

export const UserStatusLabels: Record<IUserStatusEnum, string> = {
  [IUserStatusEnum.Active]: 'ADMIN_USER_STATUS_ACTIVE',
  [IUserStatusEnum.Unspecified]: 'ADMIN_USER_STATUS_UNSPECIFIED',
  [IUserStatusEnum.Blocked]: 'ADMIN_USER_STATUS_BLOCKED',
  [IUserStatusEnum.Deleted]: 'ADMIN_USER_STATUS_DELETED',
};

export enum IUserRoleEnum {
  UserAdmin = 'USER_ROLE_ADMIN',
  UserOperator = 'USER_ROLE_OPERATOR',
}

export const UserRolesLabels: Record<IUserRoleEnum, string> = {
  [IUserRoleEnum.UserAdmin]: 'ADMIN_USER_ROLE_ADMIN',
  [IUserRoleEnum.UserOperator]: 'ADMIN_USER_ROLE_OPERATOR',
};

export interface IUserListFilterModel {
  page_index?: number;
  page_size?: number;
  activity_start_date?: number | string;
  activity_end_date?: number | string;
  status?: IUserStatusEnum;
  is_employee?: boolean;
  q?: string;
  q_by?: number;
}

export interface IUserActivityResponseModel extends IBaseResponseModel {
  userActivities: IUserActivity[];
}

export interface IUserActivity {
  uuid: string;
  userUuid: string;
  eventType: IUserActivityEventEnum;
  date: string;
  action: IUserActionEnum;
  diffData: IActivityDiffData;
}

export enum IUserActionEnum {
  Abonement = 'Abonement',
  AbonementGrant = 'AbonementGrant',
  BenefitGrant = 'BenefitGrant',
  Category = 'Category',
  SubCategory = 'SubCategory',
  Zone = 'Zone',
  Settings = 'Settings',
  Parkomat = 'Parkomat',
  Parking = 'Parking',
  PaymentPoint = 'PaymentPoint',
  User = 'User',
  Tariff = 'Tariff',
  Password = 'Password',
  Benefit = 'Benefit',
}

export enum IUserActivityEventEnum {
  Create = 'create',
  Edit = 'edit',
  Delete = 'delete',
}

export interface IActivityDiffData {
  newValue: IActivityDiffValue;
  oldValue: IActivityDiffValue;
}

export interface IActivityDiffValue {
  fields: IDiffField;
}

export interface IDiffField {
  new_value?: string;
  old_value?: string;
}
